import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { languageValidationParameter } from '../constants';
import { ExternalUrlGroupItem, ExternalUrlGroupsItemValidation } from '../types-store';
import { ExternalUrlGroupsTranslation } from 'app/area/external-url-groups/constants';
import { ExternalUrlFormIds } from 'app/area/external-url-groups/form/constants';

const validationMessageHelper = (propName: string, messages: ValidationMessage | ValidationMessage[]) => {
  return {
    [propName]: {
      level: ValidationLevel.error,
      messages
    }
  };
};

export const validateExternalUrlGroup = (
  externalUrlGroupItem: ExternalUrlGroupItem,
  languageOptions: ComplexValue<number>[],
  translation: ExternalUrlGroupsTranslation
): ExternalUrlGroupsItemValidation => {

  const defaultValidationError = {
    level: ValidationLevel.error,
    message: translation.must_be_filled_out
  };

  const allLanguages = (languageOptions || [])
    .map(option => (externalUrlGroupItem && externalUrlGroupItem.language || [])
      .find(language => language.value === option.value)
      || { value: option.value }
    );

  const languageValidation = allLanguages
    .map(language =>
      language.description === undefined || language.description.trim() === ''
        ? {
          ...defaultValidationError,
          parameters: {
            [languageValidationParameter]: language.value
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const caseTypeValidation = externalUrlGroupItem?.accessPolicy
    ?.map(item =>
      item.caseType?.value === undefined || item.caseType?.description.trim() === ''
        ? {
          ...defaultValidationError,
          parameters: {
            id: item.id
          }
        } as ValidationMessage
        : undefined
    )
    ?.filter(validation => !!validation);

  const operationValidation = externalUrlGroupItem?.accessPolicy
    ?.map(item =>
      item.operation?.value === undefined || item.operation?.description.trim() === ''
        ? {
          ...defaultValidationError,
          parameters: {
            id: item.id
          }
        } as ValidationMessage
        : undefined
    )
    ?.filter(validation => !!validation);

  return {
    ...(languageValidation.length > 0 && validationMessageHelper(ExternalUrlFormIds.language, languageValidation)),
    ...(caseTypeValidation?.length > 0 && validationMessageHelper(ExternalUrlFormIds.caseType, caseTypeValidation)),
    ...(operationValidation?.length > 0 && validationMessageHelper(ExternalUrlFormIds.operation, operationValidation))
  };
};
